export default {
  // Mapping với subsystemcode trên server
}
